import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import Item from "./Item";
import moment from "moment";
const { Title } = Typography;

const OrderDetails = (props) => {
  const { order } = props;
  const intl = useIntl();

  const filtered =
    order["client.service_types"] &&
    order["client.service_types"].filter((i) => i.id === order.service_type)[0];
  return (
    <div style={{ width: "100%" }}>
      <div className="section" style={{ width: "100%" }}>
        <Title level={5}>
          {intl.formatMessage({
            id: "app.order_print.details",
          })}
        </Title>
        <div className="rowContainer">
          <Item
            name="service_type"
            content={filtered ? filtered.name : ""}
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item
            name="max_hours"
            content={order.max_hours}
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item
            name="max_hours_per_month"
            content={order.max_hours_per_month}
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item
            name="effective_from"
            content={
              order.effective_from &&
              moment(order.effective_from).format("DD/MM/YYYY")
            }
            line_type="vertical"
          />
          <div className="horizontal_spacer" />
          <Item
            name="effective_to"
            content={
              order.effective_to &&
              moment(order.effective_to).format("DD/MM/YYYY")
            }
            line_type="vertical"
          />
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
